var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeoutBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 400,
    viewBox: "0 0 1440 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_242_5926)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 480,
    fill: "url(#paint0_linear_242_5926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1867.16 658.456C1867.16 658.456 1607.36 744.011 1385.69 703.885C1164.02 663.758 1091.66 505.23 1178.82 267.418C1265.98 29.6053 1039.63 -49.4853 1039.63 -49.4853C1039.63 -49.4853 2023.19 -164.732 1867.16 658.456Z",
    fill: "url(#paint1_linear_242_5926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-190.381 14.2387C-190.381 14.2387 82.706 -1.16081 286.439 94.9711C490.171 191.103 519.035 362.957 373.294 570.108C227.553 777.258 425.714 912.236 425.714 912.236C425.714 912.236 -554.155 768.992 -190.381 14.2387Z",
    fill: "url(#paint2_linear_242_5926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.145 466.219C74.7769 223.589 265.83 -26.1088 390.777 -120.629L96.7557 -593.642C-377.683 -572.961 -1305.34 301.672 -706.014 -81.773C-78.8769 -483.012 151.277 590.504 60.7735 830.574C241.967 810.218 545.512 708.849 310.145 466.219Z",
    fill: "url(#paint3_radial_242_5926)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip1_242_5926)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M728.858 0L215.635 520H753.774L1035.63 0H728.858Z",
    fill: "url(#paint4_linear_242_5926)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M847.207 0L426.59 520H571.322L963.733 0H847.207Z",
    fill: "url(#paint5_linear_242_5926)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M772.461 0L367.866 520H309.072L752.218 0H772.461Z",
    fill: "url(#paint6_linear_242_5926)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M995.145 0L630.201 520H690.664L1019.99 0H995.145Z",
    fill: "url(#paint7_linear_242_5926)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_242_5926",
    x1: 720,
    y1: 480,
    x2: 636.964,
    y2: 14.8222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_242_5926",
    x1: 1409.87,
    y1: 790.739,
    x2: 1230.67,
    y2: 138.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_242_5926",
    x1: 288.376,
    y1: 211.336,
    x2: 387.206,
    y2: 728.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000C2A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_242_5926",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-549.775 -1233.87) rotate(64.1975) scale(1853.61 1190.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AABFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_242_5926",
    x1: 940.104,
    y1: -45.6702,
    x2: 597.567,
    y2: 389.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_242_5926",
    x1: 937.042,
    y1: -10.498,
    x2: 484.362,
    y2: 575.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_242_5926",
    x1: 772.636,
    y1: -13.5,
    x2: 467.156,
    y2: 349.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_242_5926",
    x1: 1008.63,
    y1: -0.0000133349,
    x2: 658.962,
    y2: 542.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_5926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 480,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_242_5926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 820,
    height: 520,
    fill: "white",
    transform: "translate(215.635)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeoutBackground);
export default __webpack_public_path__ + "static/media/TimeoutBackground.52ed43bcc4d5f0ef6c93a1af9655017e.svg";
export { ForwardRef as ReactComponent };